const convenio = [
    {
        key: "numeroContrato",
        label: "Número de convenio",
        sortable: false,
    },
    {
        key: "tarifa",
        label: "Tarifa",
        sortable: false,
    },
    {
        key: "descuento",
        label: "Descuento",
        sortable: false, 
    },
    {
        key: "garantia",
        label: "Garantia",
        sortable: false,
    },
    {
        key: "lineaCredito",
        label: "Línea de crédito",
        sortable: false,
    },
    {
        key: "saldo",
        label: "Saldo",
        sortable: false,
    },
    {
        key: "facturado",
        label: "Deuda facturada",
        sortable: false,
    },
    {
        key: "nombreEjecutivo",
        label: "Nombre de ejecutivo de venta",
        sortable: false,
    },
    {
        key: "plazoPago",
        label: "Plazo de pago",
        sortable: false,
    },
    {
        key: "descargar",
        label: "Descargar",
        sortable: false,
    }
];

module.exports = {
    convenio
};
